import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `MergeContentRoot`,
  grid: `MergeContentGrid`
};

export function useMergeContentStyles() {
  const { effects } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [classNames.root, { height: `100%` }],
      grid: [
        classNames.grid,
        {
          boxShadow: effects.elevation8,
          padding: `15px`
        }
      ]
    }),
    [effects]
  );
}
